module.exports = __webpack_public_path__ + "img/leveler-1-off.715b6edf.png";